import styled from "styled-components";

export const CustomsPaging = styled.div`
	.pagination {
		display: flex;
		flex-direction: row;
		margin: 0;
	}

	.pagination .page-item {
		color: #637381;
		font-size: 0.875rem;
		cursor: pointer;
		text-underline-offset: 2px;
		text-decoration-line: underline;
		margin-right: 5px;
	}

	.pagination .page-item.page-item-break {
		text-underline-offset: 0;
		text-decoration-line: none;
	}

	.pagination .page-item.active {
		text-decoration-line: none;
	}

	.pagination .page-item.page-item-disabled {
		display: none;
	}
`;
